import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=948f22ac&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=js&"
export * from "./Bookings.vue?vue&type=script&lang=js&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=948f22ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f22ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
